import { Button } from 'components/buttons'
import { twJoin } from 'tailwind-merge'

export const TableButton = ({
  children,
  onClick,
  variant = 'primary',
}: {
  children: React.ReactNode
  onClick: () => void
  variant?: 'primary' | 'danger'
}) => {
  return (
    <Button
      variant="subtle"
      onClick={onClick}
      className={twJoin(
        variant === 'primary' ? 'text-primary-700' : 'text-error-500',
        'p-0 text-sm',
      )}
    >
      {children}
    </Button>
  )
}
